export const authenticatorApi = {
    authenticator2FA:'v1/api/authenticators',
    updatedUser:'v1/api/authenticators/updateAuthenticator'
}